import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import QuizPage from './pages/QuizPage';
import GameOverPage from './pages/GameOverPage';
import { QuizSettings, QuizResults } from './types/quiz';
import { useHighScore } from './hooks/useHighScore';
import HighScoreDisplay from './components/HighScoreDisplay';
import './App.css';
import GlobalStyles from './styles/GlobalStyles';

function App() {
  const [quizSettings, setQuizSettings] = useState<QuizSettings>({
    amount: 10,
    category: 'any',
    difficulty: 'any',
    type: 'multiple',
    lives: 3,
    skips: 2,
    mode: 'endless'
  });
  
  const [quizResults, setQuizResults] = useState<QuizResults>({
    score: 0,
    totalQuestions: 0
  });
  
  const { highScore, isNewHighScore, checkHighScore, resetNewHighScoreFlag } = useHighScore();
  
  const handleStartQuiz = (settings: QuizSettings) => {
    setQuizSettings(settings);
  };
  
  const handleGameOver = (results: QuizResults) => {
    setQuizResults(results);
    checkHighScore(results.score);
  };
  
  const handleRestart = () => {
    // Reset quiz settings to default if needed
    setQuizSettings(prev => ({
      ...prev,
      amount: 10,
      category: 'any',
      difficulty: 'any',
      type: 'multiple',
      lives: 3,
      skips: 2,
      mode: 'endless'
    }));
    
    // Reset quiz results
    setQuizResults({
      score: 0,
      totalQuestions: 0
    });
  };

  return (
    <Router>
      <GlobalStyles />
      <div className="App" style={{ paddingTop: '40px' }}>
        <HighScoreDisplay 
          highScore={highScore} 
          isNewHighScore={isNewHighScore} 
          onAnimationComplete={resetNewHighScoreFlag}
        />
        <Routes>
          <Route path="/" element={<HomePage onStartQuiz={handleStartQuiz} />} />
          <Route 
            path="/quiz" 
            element={
              quizSettings ? 
              <QuizPage settings={quizSettings} onGameOver={handleGameOver} /> : 
              <Navigate to="/" />
            } 
          />
          <Route 
            path="/game-over" 
            element={
              quizResults.totalQuestions > 0 ? 
              <GameOverPage 
                score={quizResults.score} 
                totalQuestions={quizResults.totalQuestions} 
                onRestart={handleRestart}
                settings={quizSettings} 
              /> : 
              <Navigate to="/" />
            } 
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
